import { render, staticRenderFns } from "./ShareholderChart.vue?vue&type=template&id=16ca2ab5&scoped=true"
import script from "./ShareholderChart.vue?vue&type=script&setup=true&lang=js"
export * from "./ShareholderChart.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ShareholderChart.vue?vue&type=style&index=0&id=16ca2ab5&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16ca2ab5",
  null
  
)

export default component.exports